const schema = {
  currentProjectEntitlements: value => {
    return value && typeof value === 'object';
  },
  currentUser: value => {
    return value && typeof value === 'object';
  },
  usersInProject: value => {
    return value && Array.isArray(value);
  },
  rolesInProject: value => {
    return value && Array.isArray(value);
  },
  companiesInProject: value => {
    return value && Array.isArray(value);
  },
  hostingAppName: value => {
    return value && typeof value === 'string';
  }
};
const validate = createFormProps =>
  createFormProps && Object.keys(schema).every(prop => schema[prop](createFormProps[prop]));

export default validate;
